var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4284 9.28571C23.4927 9.28571 25.0713 10.8643 25.0713 12.9286V16.5714H27.4998V12.9286C27.4998 10.0143 25.3141 7.46429 22.5213 6.97857C22.0355 4.18571 19.4855 2 16.5713 2H3.21411V31.1429H17.7855V28.7143H5.64268V4.42857H16.5713C18.6355 4.42857 20.2141 6.00714 20.2141 8.07143V9.28571H21.4284ZM9.28554 10.5V12.9286H14.1427V10.5H9.28554ZM9.28554 17.7857H20.2141V15.3571H9.28554V17.7857Z",
    fill: "#F57F7F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_885_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1818 18.0684C27.389 18.0684 29.1308 19.7293 29.131 21.8496V23.2422H29.8185C30.7121 23.2423 31.4493 23.9427 31.4493 24.8066V32.1982C31.4491 33.0619 30.712 33.7616 29.8185 33.7617H20.546C19.6524 33.7617 18.9145 33.062 18.9142 32.1982V24.8066C18.9142 23.9427 19.6523 23.2422 20.546 23.2422H21.2325V21.8496C21.2327 19.7293 22.9746 18.0684 25.1818 18.0684ZM20.631 32.1123H29.7325V24.8926H20.631V32.1123ZM25.1818 26.9385C26.0755 26.9385 26.8135 27.638 26.8136 28.502C26.8136 29.3659 26.0755 30.0664 25.1818 30.0664C24.2881 30.0663 23.5509 29.3659 23.5509 28.502C23.551 27.6381 24.2882 26.9386 25.1818 26.9385ZM25.1818 19.6445C23.9121 19.6446 22.8724 20.6442 22.8722 21.8496V23.2422H27.4913V21.8496C27.4911 20.6442 26.4515 19.6445 25.1818 19.6445Z",
    fill: "#F57F7F",
    stroke: "#F57F7F",
    strokeWidth: 0.171589
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_885_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.443,
    height: 17.1589,
    fill: "white",
    transform: "translate(17.443 17.4434)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/Closed.57021e748b772c1c122501cf3e338360.svg";
export { ForwardRef as ReactComponent };